import React, { memo, forwardRef } from "react";
const SvgCapitalO = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M23.61 15.96c0 1.107-.193 2.12-.58 3.04a6.995 6.995 0 01-1.58 2.36 7.435 7.435 0 01-2.42 1.54c-.933.36-1.953.54-3.06.54-1.093 0-2.107-.18-3.04-.54a7.488 7.488 0 01-2.4-1.54A7.41 7.41 0 018.95 19c-.373-.92-.56-1.933-.56-3.04 0-1.133.187-2.153.56-3.06.387-.92.913-1.7 1.58-2.34a7.124 7.124 0 012.4-1.48c.934-.347 1.947-.52 3.04-.52 1.107 0 2.127.173 3.06.52.933.347 1.74.84 2.42 1.48.68.64 1.207 1.42 1.58 2.34.387.907.58 1.927.58 3.06zm-2.74 0c0-.733-.12-1.413-.36-2.04a4.84 4.84 0 00-.98-1.64 4.58 4.58 0 00-1.54-1.1c-.6-.267-1.266-.4-2-.4-.733 0-1.4.133-2 .4a4.636 4.636 0 00-1.52 1.1 5.114 5.114 0 00-1 1.64 5.957 5.957 0 00-.34 2.04c0 .76.113 1.46.34 2.1.24.627.573 1.173 1 1.64.44.467.954.833 1.54 1.1.6.253 1.26.38 1.98.38s1.38-.127 1.98-.38a4.58 4.58 0 001.54-1.1 4.682 4.682 0 001-1.64c.24-.64.36-1.34.36-2.1z"
      />
    </svg>
  );
});
SvgCapitalO.displayName = "SvgCapitalO";
const MemoForwardRef = memo(SvgCapitalO);
export default MemoForwardRef;
